module.exports = __webpack_public_path__ + "static/media/Home_active_Blue.51b28bf4.svg";